import ApplicativeAccountsManagement from "./ApplicativeAccountsManagement";
import WithLayout from "src/Components/Layout/Layout";

export default WithLayout(ApplicativeAccountsManagement);